/* MSM content pages 2026 - DRAFT 2026-10-06. Read-more toggles (text stays in the HTML) + "check your postcode" button
   that opens the theme's own header postcode checker (snippets/hp26-postcode.liquid). No dependencies. */
(function(){
  function initRM(el){
    if(el.dataset.ready)return; el.dataset.ready='1';
    var body=el.querySelector('.msm26-rm__body'),btn=el.querySelector('.msm26-rm__btn');
    if(!body||!btn)return;
    el.classList.add('is-clamped');
    if(body.scrollHeight<=body.clientHeight+24){el.classList.remove('is-clamped');btn.hidden=true;return;}
    btn.hidden=false;
    btn.addEventListener('click',function(){
      var open=el.classList.toggle('is-clamped')===false;
      btn.setAttribute('aria-expanded',open?'true':'false');
      btn.textContent=open?(btn.dataset.less||'Read less'):(btn.dataset.more||'Read more');
    });
  }
  function initPC(b){
    if(b.dataset.ready)return; b.dataset.ready='1';
    b.addEventListener('click',function(e){
      var input=document.getElementById('hp26-pc-input'),tog=document.querySelector('[data-hp26-pc] [data-pc-tog]');
      var visible=function(x){return x&&x.offsetParent!==null&&x.getBoundingClientRect().width>0;};
      if(!input&&!tog)return; /* no header checker: follow the link to the delivery page */
      e.preventDefault();
      var chg=document.querySelector('[data-hp26-pc] [data-pc-change]');
      if(visible(chg))chg.click();
      window.scrollTo({top:0,behavior:'smooth'});
      setTimeout(function(){
        if(visible(input)){input.focus();return;}
        if(tog){tog.click();setTimeout(function(){if(input)input.focus();},150);}
      },350);
    });
  }
  function init(root){
    (root||document).querySelectorAll('.msm26-rm').forEach(initRM);
    (root||document).querySelectorAll('[data-msm26-pc]').forEach(initPC);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init();});else init();
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();
